import { Injectable } from '@angular/core';
import { Time } from 'app/shared/models/time';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService {
  private timeSubject = new BehaviorSubject<Time>({
    time: null,
    date: null,
    dateTime: null
  });

  time$ = this.timeSubject.asObservable();

  // Method to update the time value
  updateTime(time: Time) {
    this.timeSubject.next(time);
  }
}